<template>
  <layout :title-text="title">
    <div slot="content">
      <swiper/>
    </div>
  </layout>
</template>

<script>
import Layout from '@components/layout'
import Swiper from '@components/swiper'
export default {
  components: {
    Layout,
    Swiper
  },
  data () {
    return {
      title: '往届照片'
    }
  }
}
</script>

<style lang="less" scoped>
</style>
